var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cliente-form',{attrs:{"idBusiness":_vm.idBusiness,"idCliente":_vm.idCliente,"pag":_vm.pag,"idCompany":_vm.idCompany,"filtro":_vm.filter}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fdb7df8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Configuracion/Clientes/Cliente.vue
// module id = 07hc
// module chunks = 4